var map = {
	"./AutomateBLogoWhiteOrange.png": 48835,
	"./BOSS Logo_PNG.png": 42581,
	"./BossStudioLogo.png": 69118,
	"./CardIcon.png": 73671,
	"./Grid2ColumnIcon.png": 27097,
	"./Grid3ColumnIcon.png": 29573,
	"./Grid4ColumnIcon.png": 6687,
	"./HeroBanner2.png": 44472,
	"./HeroBannerIcon.png": 14669,
	"./Logo.png": 50330,
	"./LogoIcon.png": 32854,
	"./RailIcon.png": 39334,
	"./RailIcon1.png": 40853,
	"./TextIcon.png": 81013,
	"./The-Power-of-Billboard-Advertising-1.jpg": 57926,
	"./VerticalRail.png": 54695,
	"./activatescreen.png": 15449,
	"./amazonfiretv.png": 67533,
	"./android.png": 92463,
	"./android1.png": 18821,
	"./automatbLogo.png": 80253,
	"./bingingLogo.png": 3003,
	"./createplaylist.png": 66105,
	"./dswelcome.png": 90607,
	"./noRecords.jpeg": 56209,
	"./p1.png": 33706,
	"./p2.png": 30106,
	"./p3.png": 32195,
	"./p4.png": 15883,
	"./p5.png": 50706,
	"./p6.png": 73692,
	"./qrapp.png": 87203,
	"./qrcode.png": 72462,
	"./uploadcontent.png": 11509,
	"./user-guide.png": 67305,
	"./welcomescreen.png": 64115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51327;